export { CustomerReviews } from './lib/customer-reviews'
export { getStaticProps } from './lib/get-static-props'
export type { CustomerReviewsProps } from './lib/get-static-props'
export type { CustomerReviewsPageStoryContent } from './lib/types/customer-reviews-page'
